import { Button } from '@/ui-components/Button'
import { Heading } from '@/ui-components/Heading'
import { Text } from '@/ui-components/Text'

const NotFound = () => {
  return (
    <main className="grid min-h-full place-items-center bg-white dark:bg-gray-900 px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <Text className="text-base font-semibold text-indigo-600 dark:text-indigo-400">404</Text>
        <Heading level={1}>Page not found</Heading>
        <Text>Sorry, we couldn't find the page you're looking for.</Text>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Button
            to="/"
            color="primary"
          >
            Go to sign up
          </Button>

          <Button
            outline
            to="https://ankorsoftware.productfruits.help"
            target="_blank"
          >
            Contact support <span aria-hidden="true">&rarr;</span>
          </Button>
        </div>
      </div>
    </main>
  )
}

export default NotFound
